import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { THEMES } from "../../utils/constants";

interface Theme {
  theme: string;
}

export const themeSlice = createSlice({
  name: "theme",
  initialState: {
    theme: THEMES.light,
  },
  reducers: {
    changeTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload.theme;
    },
  },
});

export const { changeTheme } = themeSlice.actions;
